export default function defaultFormatter(value, _unit, suffix) {
  const unit = value !== 1 ? _unit + 's' : _unit;
  return value + ' ' + unit + ' ' + suffix;
}